export default {
  title: 'Practice Group Report',
  backButton: 'All reports',
  practiceGroupFilterLabel: 'Filter by Practice Group',
  export: 'Export',
  adminBackButton: 'Back to MBD Reports',
};
